<template>
    <div id="enter-name-gender"> 
        <p>Ist Ihr größter Schatz ein Junge oder ein Mädchen?</p>
        <div class="rv-selectTitle">
            <b-container fluid class="rv-selectionOption first" v-on:click="selectBoy">
                <b-row>
                    <b-col v-bind:class="['rv-title', this.boySelected() ? 'selected' : '']">
                        <b-row>
                            <b-col  md="auto" class="rv-titleThumbnail greetings">
                               <img srcset="@/assets/placeholder/schatzbuch/placeholder_boy_1x.png 1x, @/assets/placeholder/schatzbuch/placeholder_boy_2x.png 2x, @/assets/placeholder/schatzbuch/placeholder_boy_3x.png 3x" src="@/assets/placeholder/schatzbuch/placeholder_boy_1x.png"/>       
                            </b-col>
                            <b-col class="rv-titleDescription"><span>Junge</span></b-col>
                        </b-row>
                         <div class="check-icon" v-if="this.boySelected()">
                            <font-awesome-icon icon="check-circle"></font-awesome-icon>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <div class="rv-selectDivider">
                <hr class="rv-divider first"/> 
                <span class="rv-divider-text">oder</span> 
                <hr class="rv-divider second"/>
            </div>
            <b-container fluid class="rv-selectionOption second" v-on:click="selectGirl">
                <b-row>
                    <b-col v-bind:class="['rv-title', this.girlSelected() ? 'selected' : '']">
                        <b-row>
                            <b-col md="auto" class="rv-titleThumbnail picture">
                                <img srcset="@/assets/placeholder/schatzbuch/placeholder_girl_1x.png 1x, @/assets/placeholder/schatzbuch/placeholder_girl_2x.png 2x, @/assets/placeholder/schatzbuch/placeholder_girl_3x.png 3x" src="@/assets/placeholder/schatzbuch/placeholder_girl_1x.png"/>
                            </b-col>
                            <b-col class="rv-titleDescription"><span>Mädchen</span></b-col>
                        </b-row>
                         <div class="check-icon" v-if="this.girlSelected()">
                            <font-awesome-icon icon="check-circle"></font-awesome-icon>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script type="ts">
import { Module, VuexModule, getModule } from 'vuex-module-decorators'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { Gender} from '@/rest/models'
import { TreasureBookModule } from '@/store/modules/treasureBook'

export default {
    name: 'enter-name-gender',
    data: function() {
        return {
        }
    },
    methods: {
        onCancel: function() {
            this.$emit('cancel');
        },
        selectGirl: function(){
            TreasureBookModule.SetChildGender(Gender.Female)
            this.$emit('showNameText');
        },
        selectBoy: function(){
            TreasureBookModule.SetChildGender(Gender.Male)
            this.$emit('showNameText');
        },
        girlSelected: function() {
            return (TreasureBookModule.childGender === Gender.Female)
        },
        boySelected: function() {
            return (TreasureBookModule.childGender === Gender.Male)
        },
    },
    components: {
    }
}
</script>


<style lang="scss">
#enter-name-gender{
     .rv-selectTitle{
        max-width: 455px;
        margin: 0px auto;
        .rv-selectDivider{
            .rv-divider-text{
                    display: inline-block;
                    font-variant: small-caps;
                    font-weight: 700;
                    position: relative;
                    top: -2px;
                }

            margin: 5px 0px;
            .rv-divider{ 
                display: inline-block;
                margin: 5px 0px;
                background-color:#656565;

                &.first{
                    width: 120px;
                    margin-right: 5px;
                }
                &.second{
                    width: 280px;
                    margin-left: 5px;
                }   

                @media (max-width: $rv-tileBreakpoint) {
                    &.second{
                        width: 145px;
                    
                    } 
                }
            }
        }
        .rv-selectionOption{
            padding: 0px;
            .rv-title{
                cursor:pointer;
                border-radius: 3px;
                border: 1px grey solid;
                height: 120px;
                width: 100%;
                padding: 9px;
                .rv-titleThumbnail{
                    padding: 0;
                    width:100px;
                    height:100px;
                    border:1px grey solid;
                    border-radius: 3px;
                    text-align: center;
                    font-size: 10px;

                    img{
                        width: 100%;
                    }

                    &.picture {
                        p{
                            margin-bottom: -7px;
                        }
                    }
                    &.greetings {
                        p{
                            margin-bottom: 7px;
                        }
                    }
                    .rv-imageIcon{
                        color: #e9e9e9;
                    }
                    .rv-triangle{
                        width: 100px;
                        height: 100px;
                        position: absolute;
                        top: -2%;
                        left: -2%;
                        background: linear-gradient(to bottom right, transparent 0%, transparent 84.1%, #1a5dae 16%, #1a5dae 100%);

                        border-bottom-right-radius: 2px;
                    }
                }

                .rv-titleDescription{
                    padding:9px;
                    text-align:bottom;
                    &.col {
                       flex-basis: 0;
                    }
                    span{
                        line-height: 5em;                      
                    }
                }

                &.selected{
                    border: 2px solid #1a5dae;
                    padding: 8px;

                    .check-icon {
                        position: relative;
                        left: 424px;
                        top: -16px;
                        width:24px;
                        color: $rv-primary;
                        font-size: 1.5em;
                        
                        @media (max-width: $rv-tileBreakpoint) {
                            left: 289px;
                        }
                    }
                }
            }

            &.second{
                margin-bottom: 73px;
                @media (max-width: $rv-doubleTeaserBreakpoint) {
                    margin-bottom: 5px;
                }
            }
        }
    } 
}
</style>